import React from "react";
import "./Lottie_Holder.css";
import Lottie from "lottie-react";

function Lottie_Holder({ animationData }) {
  return (
    <section className="Lottie_Holder">
      <Lottie
        className="Lottie_img"
        animationData={animationData}
        loop
        autoplay
      />
    </section>
  );
}

export default Lottie_Holder;
